import { api, ChatChannel } from '../api';
import { Avatar } from '../components/Avatar';
import { IconBell, IconBuildingSmall, IconHash, IconMegaphone } from '../components/icons';

/*
 * Значок чата: загруженная картинка, а если её нет — символ по типу чата.
 * У личной переписки значок берётся у собеседника: это его лицо, а не чата.
 */



export function ChatAvatar({
  channel,
  size = 34,
}: {
  channel: Pick<ChatChannel, 'id' | 'kind' | 'name' | 'peer' | 'avatarAt' | 'projectId'>;
  size?: number;
}) {
  // чат уведомлений — колокольчик на акцентной плашке: он один такой в списке
  if (channel.kind === 'system') {
    return (
      <span className="ch-ava ch-ava-sym ch-ava-sys" style={{ width: size, height: size }}>
        <IconBell />
      </span>
    );
  }
  if (channel.kind === 'dm' && channel.peer) {
    return <Avatar login={channel.peer.login} name={channel.peer.name} size={size} />;
  }
  if (channel.avatarAt) {
    return (
      <img
        className="ch-ava"
        src={api.chatAvatarUrl(channel.id, channel.avatarAt)}
        alt={channel.name}
        width={size}
        height={size}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span className="ch-ava ch-ava-sym" style={{ width: size, height: size }}>
      {channel.projectId ? (
        <IconBuildingSmall />
      ) : channel.kind === 'channel' ? (
        <IconMegaphone />
      ) : (
        <IconHash />
      )}
    </span>
  );
}
